import { takeLatest, takeEvery } from "redux-saga/effects";
import { Types } from "../actionTypes";
import actions from "@Src/redux/rootActions";
import { getCategories } from "./CategorySaga";
import { getUserLocation } from "./UserLocationSaga";
import {
  doCheckEmailAvailability,
  doCheckRegistrationCode,
  doCheckMemberId,
  completeAccountSetup,
  createMember,
  signIn,
  signOut,
  doAuthByCvt,
  doAuthBySsoToken,
  doCompleteMemberProfile,
  validateSession,
  fetchMemberAccountInfo,
  updateMemberAccountInfo,
  getDefaultLocation,
} from "./MemberSaga";
import { getProgram } from "./ProgramSaga";
import { getDeals } from "./DealsSaga";
import {
  doSearch,
  fetchRecentSearches,
  fetchSearchSuggestions,
  getNearbyLocationsOffersSaga,
} from "./SearchSaga";

import {
  doGeoSearch,
  doGetGeoLocationDetails,
  doGetRecentLocations,
  doPostRecentLocation,
  doIpLookup,
} from "./GeoSearchSaga";
import { doGetPreferences, doPostPreferences } from "./PreferencesSaga";
import { doStore, doOffer } from "./StoreSaga";
import {
  doGetBannerDeals,
  doGetFeaturedDeals,
  doGetFavoritesNearby,
  doGetPopularBrands,
  doGetRecommendations,
  doGetHotDeals,
  doGetOurPicks,
  doGetTopOnlineDeals,
} from "./CampaignSaga";
import { addMembers, editMember, getMembers, getMember, getActiveMemberCount } from "./adminSaga";
import { doAddFavorite, doGetFavorites, doRemoveFavorite, doFavsLookup } from "./FavoritesSaga";
import {
  doGetContactMethods,
  doAddContactMethods,
  doUpdateContactMethods,
  doDeleteContactMethods,
} from "./ContactMethodsSaga";

const { fetchContactMethods, createContactMethods, updateContactMethods, deleteContactMethods } =
  actions.contactMethods;

const { fetchFavorites, addFavorite, removeFavorite, fetchFavoritedStores } = actions.favorites;

export default function* mySaga() {
  yield takeLatest(Types.CHECK_EMAIL_AVAILABILITY, doCheckEmailAvailability);
  yield takeLatest(Types.CHECK_REGISTRATION_CODE, doCheckRegistrationCode);
  yield takeLatest(Types.CHECK_MEMBER_ID, doCheckMemberId);
  yield takeLatest(Types.COMPLETE_ACCOUNT_SETUP, completeAccountSetup);
  yield takeLatest(Types.CREATE_MEMBER, createMember);
  yield takeLatest(Types.CREATE_MEMBER_SUCCESS, fetchMemberAccountInfo);
  yield takeLatest(Types.SIGN_IN, signIn);
  yield takeLatest(Types.AUTH_BY_CVT, doAuthByCvt);
  yield takeLatest(Types.AUTH_BY_SSO_TOKEN, doAuthBySsoToken);
  yield takeLatest(Types.COMPLETE_MEMBER_PROFILE, doCompleteMemberProfile);
  yield takeLatest(Types.SIGN_IN_SUCCESS, getDefaultLocation);
  yield takeLatest(Types.SIGN_IN_SUCCESS, doGetRecommendations);
  yield takeLatest(Types.SIGN_IN_SUCCESS, doGetRecentLocations);
  yield takeLatest(Types.SIGN_IN_SUCCESS, fetchRecentSearches);
  yield takeLatest(Types.SIGN_IN_SUCCESS, doGetFavorites);
  yield takeLatest(Types.SIGN_IN_SUCCESS, doGetContactMethods);
  yield takeLatest(Types.SIGN_IN_SUCCESS, fetchMemberAccountInfo);
  yield takeLatest(Types.SIGN_OUT, signOut);
  yield takeLatest(Types.VALIDATE_SESSION, validateSession);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, getDefaultLocation);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, doGetRecommendations);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, doGetRecentLocations);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, fetchRecentSearches);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, doGetFavorites);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, doGetContactMethods);
  yield takeLatest(Types.VALIDATE_SESSION_SUCCESS, fetchMemberAccountInfo);
  yield takeLatest(Types.FETCHING_PROGRAM, getProgram);
  yield takeLatest(Types.FETCHING_USERLOCATION, getUserLocation);
  yield takeLatest(Types.FETCHING_CATEGORIES, getCategories);
  yield takeLatest(Types.FETCH_BANNER_DEALS, doGetBannerDeals);
  yield takeLatest(Types.FETCH_HOT_DEALS, doGetHotDeals);
  yield takeLatest(Types.FETCH_OUR_PICKS, doGetOurPicks);
  yield takeLatest(Types.FETCH_FEATURED_DEALS, doGetFeaturedDeals);
  yield takeLatest(Types.FETCH_FAVORITES_NEARBY, doGetFavoritesNearby);
  yield takeLatest(Types.FETCH_TOP_ONLINE_DEALS, doGetTopOnlineDeals);
  yield takeLatest(Types.FETCH_POPULAR_BRANDS, doGetPopularBrands);
  yield takeLatest(Types.FETCH_RECOMMENDATIONS, doGetRecommendations);
  yield takeLatest(Types.FETCH_DEALS, getDeals);
  yield takeLatest(Types.FETCH_SEARCH_RESULTS, doSearch);
  yield takeLatest(Types.FETCH_SEARCH_RESULTS_SUCCESS, fetchRecentSearches);
  yield takeLatest(Types.FETCH_GEO_LOCATION_RESULTS, doGeoSearch);
  yield takeLatest(Types.FETCH_GEO_LOCATION_DETAILS, doGetGeoLocationDetails);
  yield takeLatest(Types.FETCH_RECENT_LOCATIONS, doGetRecentLocations);
  yield takeLatest(Types.SET_RECENT_LOCATION, doPostRecentLocation);
  yield takeLatest(Types.SET_RECENT_LOCATION_SUCCESS, doGetRecentLocations);
  yield takeLatest(Types.FETCH_IP, doIpLookup);
  yield takeLatest(Types.FETCH_STORE_LOCATION, doStore);
  yield takeLatest(Types.FETCH_OFFER_KEY, doOffer);
  yield takeLatest(Types.FETCH_MEMBER_ACCOUNT, fetchMemberAccountInfo);
  yield takeLatest(Types.UPDATE_MEMBER_ACCOUNT, updateMemberAccountInfo);
  yield takeLatest(Types.GET_PREFERENCES, doGetPreferences);
  yield takeLatest(Types.SET_PREFERENCES, doPostPreferences);
  yield takeLatest(Types.ADMIN_ADD_MEMBERS, addMembers);
  yield takeLatest(Types.ADMIN_EDIT_MEMBER, editMember);
  yield takeEvery(Types.ADMIN_GET_MEMBERS, getMembers);
  yield takeLatest(Types.ADMIN_GET_MEMBERS_SUCCESS, getActiveMemberCount);
  yield takeLatest(Types.ADMIN_GET_MEMBER, getMember);
  yield takeLatest(Types.FETCH_SEARCH_SUGGESTIONS, fetchSearchSuggestions);
  yield takeLatest(Types.GET_NEARBY_LOCATIONS_OFFERS, getNearbyLocationsOffersSaga);
  yield takeLatest(Types.FETCH_MEMBER_DEFAULT_LOCATION, getDefaultLocation);
  yield takeLatest(fetchFavorites.type, doGetFavorites);
  yield takeLatest(addFavorite.type, doAddFavorite);
  yield takeLatest(removeFavorite.type, doRemoveFavorite);
  yield takeLatest(fetchFavoritedStores.type, doFavsLookup);
  yield takeLatest(fetchContactMethods.type, doGetContactMethods);
  yield takeLatest(createContactMethods.type, doAddContactMethods);
  yield takeLatest(updateContactMethods.type, doUpdateContactMethods);
  yield takeLatest(deleteContactMethods.type, doDeleteContactMethods);
}
